/**
 * @file Defines the Console sidebar's menu items for the administrator and manager layouts.
 */
import { Link } from "react-router-dom";
import { type MenuProps } from "antd";
import {
  TeamOutlined,
  HomeOutlined,
  UserOutlined,
  TableOutlined,
  FolderOutlined,
  WalletOutlined,
  HistoryOutlined,
} from "@ant-design/icons";

type MenuItem = Required<MenuProps>["items"][number]

const LABEL_USERS = "Users";
const LABEL_GROUPS = "Groups";
const LABEL_REPORTS = "Reports";
const LABEL_CUSTOMERS = "ACH Accounts";
const LABEL_ACTIVITIES = "Activities";
const LABEL_MY_PROFILE = "My Profile";
const LABEL_ORGANIZATIONS = "Organizations";

const PATH_USERS = "/backstage/users";
const PATH_GROUPS = "/backstage/groups";
const PATH_REPORTS = "/backstage/reports";
const PATH_CUSTOMERS = "/backstage/customers";
const PATH_ACTIVITIES = "/backstage/activities";
const PATH_MY_PROFILE = "/backstage/my-profile";
const PATH_ORGANIZATIONS = "/backstage/organizations";

const REPORTS_MENU_ITEM: MenuItem = {
  key: PATH_REPORTS,
  icon: <TableOutlined />,
  label: <Link to={PATH_REPORTS}>{LABEL_REPORTS}</Link>,
};

const MY_PROFILE_MENU_ITEM: MenuItem = {
  key: PATH_MY_PROFILE,
  icon: <UserOutlined />,
  label: <Link to={PATH_MY_PROFILE}>{LABEL_MY_PROFILE}</Link>,
};

const ADMINISTRATOR_MENU_ITEMS: MenuItem[] = [
  {
    key: PATH_ORGANIZATIONS,
    icon: <HomeOutlined />,
    label: <Link to={PATH_ORGANIZATIONS}>{LABEL_ORGANIZATIONS}</Link>,
  },
  {
    key: PATH_CUSTOMERS,
    icon: <WalletOutlined />,
    label: <Link to={PATH_CUSTOMERS}>{LABEL_CUSTOMERS}</Link>,
  },
  {
    key: PATH_GROUPS,
    icon: <FolderOutlined />,
    label: <Link to={PATH_GROUPS}>{LABEL_GROUPS}</Link>,
  },
  {
    key: PATH_USERS,
    icon: <TeamOutlined />,
    label: <Link to={PATH_USERS}>{LABEL_USERS}</Link>,
  },
  {
    key: PATH_ACTIVITIES,
    icon: <HistoryOutlined />,
    label: <Link to={PATH_ACTIVITIES}>{LABEL_ACTIVITIES}</Link>,
  },
  REPORTS_MENU_ITEM,
  MY_PROFILE_MENU_ITEM,
];

const MANAGER_MENU_ITEMS: MenuItem[] = [
  REPORTS_MENU_ITEM,
  MY_PROFILE_MENU_ITEM,
];

export {
  MANAGER_MENU_ITEMS,
  ADMINISTRATOR_MENU_ITEMS,
};

export type { MenuItem };
